import { useEffect, useRef } from 'react';

interface ScanLinesProps {
  isDarkMode: boolean;
}

/**
 * Horizontal scan lines moving upward - CRT monitor effect
 */
const ScanLines = ({ isDarkMode }: ScanLinesProps) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // Set canvas size
    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener('resize', resize);

    let animationId: number;
    let offset = 0;

    const draw = () => {
      const { width, height } = canvas;
      ctx.clearRect(0, 0, width, height);

      // Scan line settings
      const lineSpacing = 4;
      const lineOpacity = isDarkMode ? 0.15 : 0.08;

      offset += 0.5;
      if (offset > lineSpacing) offset = 0;

      ctx.strokeStyle = `rgba(0, 242, 254, ${lineOpacity})`; // Cyan
      ctx.lineWidth = 1;

      // Draw horizontal lines
      for (let y = -offset; y < height; y += lineSpacing) {
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.lineTo(width, y);
        ctx.stroke();
      }

      animationId = requestAnimationFrame(draw);
    };

    draw();

    return () => {
      cancelAnimationFrame(animationId);
      window.removeEventListener('resize', resize);
    };
  }, [isDarkMode]);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
        opacity: 0.3,
      }}
    />
  );
};

export default ScanLines;
